
import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: '¿Cuál es el tiempo de entrega de los módulos?',
      answer: 'En Santiago entregamos en 24-48 horas. Para regiones, el tiempo varía entre 3-7 días dependiendo de la ubicación. Todos nuestros módulos se fabrican bajo pedido para garantizar la máxima calidad.'
    },
    {
      question: '¿Qué incluye el precio de venta?',
      answer: 'El precio incluye el módulo completamente equipado con ventanas, puertas, sistema eléctrico básico, aislación térmica y despacho gratuito en Santiago. La instalación tiene un costo adicional según la complejidad del terreno.'
    },
    {
      question: '¿Cuáles son las condiciones de arriendo?',
      answer: 'Ofrecemos contratos desde 1 mes con opción de renovación. Incluye mantenimiento básico y opción de compra al finalizar el contrato. Se requiere garantía equivalente a 2 meses de arriendo.'
    },
    {
      question: '¿Necesito permisos especiales para instalar un módulo?',
      answer: 'Depende del uso y ubicación. Para uso temporal (menos de 2 años) generalmente no se requieren permisos especiales. Para instalaciones permanentes, te asesoramos con la documentación necesaria.'
    },
    {
      question: '¿Los módulos resisten condiciones climáticas extremas?',
      answer: 'Sí, nuestros módulos están diseñados para resistir vientos de hasta 120 km/h, lluvia intensa y variaciones de temperatura. Cuentan con aislación térmica y estructuras reforzadas.'
    },
    {
      question: '¿Ofrecen personalización de los módulos?',
      answer: 'Absolutamente. Podemos modificar distribución interior, agregar divisiones, cambiar tipos de ventanas, incluir sistemas de climatización y adaptar el módulo a tus necesidades específicas.'
    },
    {
      question: '¿Qué garantía tienen los módulos?',
      answer: 'Ofrecemos 2 años de garantía en estructura principal y 1 año en accesorios (ventanas, puertas, sistema eléctrico). Incluye soporte técnico y reemplazo de piezas defectuosas.'
    },
    {
      question: '¿Cuánto tiempo toma la instalación?',
      answer: 'Los módulos plegables se instalan en 2-4 horas con nuestro equipo técnico. Los auto armables pueden instalarse en 1-2 horas y no requieren herramientas especiales.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="preguntas" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Preguntas Frecuentes
          </h3>
          <p className="text-xl text-gray-600">
            Resolvemos las dudas más comunes sobre nuestros módulos plegables y servicios.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h4 className="text-lg font-semibold text-gray-900 pr-4">{faq.question}</h4>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-blue-600 text-xl flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">¿No encontraste la respuesta que buscabas?</p>
          <button 
            onClick={() => {
              const element = document.getElementById('contacto');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Contáctanos Directamente
          </button>
        </div>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
}
